import React, { createContext, useState } from 'react'
import useLocalStorage from '../hooks/useLocalStorage'
import useFetch from '../hooks/useFetch'
import { API_BASE_URL } from "../constant";
import errorInternal from "../assets/internal-server-error.svg";
import { useTranslation } from "react-i18next";
import header from "../assets/bank-assets/background.jpg";
import instagram from "../assets/logos/instagram.png";
import facebook from "../assets/logos/facebook.png";
import linkedIn from "../assets/logos/LinkedIn.png";
import greenNumber from "../assets/icons/numero_vert.png";
import condor from "../assets/brands/condor.svg";
import logo_footer from "../assets/logoFooter.svg";
import Navbar_500 from "../components/Navbar_500";


const StoreContext = createContext(null)

const Footer_t = () => {
    const { t } = useTranslation();
    return (
        <footer
            className="px-3 py-8 text-2 text-gray-200  transition-colors duration-200"
            style={{
                backgroundImage: `url(${header})`
            }}>
            <div className="flex flex-col">
                <div className="md:hidden mt-7 mx-auto w-11 h-px rounded-full">
                </div>
                <div className="mt-4 md:mt-0 flex flex-col md:flex-row">
                    <nav
                        className="flex-1 flex flex-col items-center justify-center md:items-end md:border-r border-gray-100 md:pr-5">
                        <a aria-current="page" href="/eligibility"
                            className="hover:text-gray-700 dark:hover:text-white">
                            {t('home.Criteria')}
                        </a>
                        <a aria-current="page" href="/dossier" className="hover:text-gray-700 dark:hover:text-white">
                            {t('home.fileProvided')}
                        </a>
                        <a aria-current="page" href="/contact" className="hover:text-gray-700 dark:hover:text-white">
                            {t('home.contactUs')}
                        </a>
                    </nav>
                    <div className="md:hidden mt-4 mx-auto w-11 h-px rounded-full">
                    </div>
                    <div className="mt-4 md:mt-0 flex-1 flex items-center justify-center md:border-r border-gray-100">
                        <a rel="noopener noreferrer" href="https://www.condor.dz/" target="_blank" title="Condor"
                            className="flex items-center justify-center pb-2 w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-violet-400 dark:text-gray-900">
                            <img className="" src={condor} />
                        </a>
                        <a rel="noopener noreferrer" href="https://www.instagram.com/condor_electromenager/?hl=fr"
                            target="_blank" title="Instagram"
                            className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-violet-400 dark:text-gray-900">
                            <img className="w-1/2" src={instagram} />
                        </a>
                        <div
                            className="flex flex-col items-center justify-center w-1/3 h-1/3 mx-8 rounded-full sm:w-1/3 sm:h-1/3 dark:bg-violet-400 dark:text-gray-900">
                            <a rel="noopener noreferrer" href="https://e-faciliti.dz/"
                                target="_blank" title="E-Faciliti"
                            // className="flex items-center justify-center w-12 h-12 mx-8 rounded-full sm:w-1/3 sm:h-1/3 dark:bg-violet-400 dark:text-gray-900"
                            >
                                <img className="w-full" src={logo_footer} />
                            </a>
                            <a rel="noopener noreferrer" href="https://e-faciliti.dz/"
                                target="_blank" title="E-Faciliti"
                                className="flex items-center justify-center mt-2 "
                            >
                                <img className="w-1/2" src={greenNumber} />
                            </a>
                        </div>
                        <a rel="noopener noreferrer" href="https://fr-fr.facebook.com/Condor.Electromenager"
                            target="_blank"
                            title="Facebook"
                            className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-violet-400 dark:text-gray-900">
                            <img className="w-1/2" src={facebook} />
                        </a>
                        <a rel="noopener noreferrer" href="https://fr.linkedin.com/company/condor-algerie"
                            target="_blank"
                            title="LinkedIn"
                            className="flex items-center justify-center w-8 h-8 rounded-full sm:w-10 sm:h-10 dark:bg-violet-400 dark:text-gray-900">
                            <img className="w-1/2" src={linkedIn} />
                        </a>
                    </div>
                    <div className="md:hidden mt-4 mx-auto w-11 h-px rounded-full ">
                    </div>
                    <div
                        className="mt-7 md:mt-0 flex-1 flex flex-col items-center justify-center md:items-start md:pl-5">
                        <span className="">
                            ©  2022
                        </span>
                        <span className="mt-7 md:mt-1">
                            <a className="underline mx-2 hover:text-gray-200" href="https://www.condor.dz/" target="_blank"
                                title="Condor">
                                SPA Condor Electronics
                            </a>
                            tous droits réservés
                        </span>
                    </div>
                </div>
            </div>
        </footer>);
}

const Error500 = () => {
    return <>
        <Navbar_500 />
        <div className="grid place-items-center text-center">
            <img className="w-2/5" alt="error500" src={errorInternal} />
        </div>
        <Footer_t />
    </>;
}


const StoreProvider = ({ children }) => {
    const [cart, setCart] = useLocalStorage('commerce_cart', [])

    // Store Filtration
    const [query, setQuery] = useState('')
    const [categoryIndex, setCategoryIndex] = useState(-1)
    const [companyIndex, setCompanyIndex] = useState(-1)
    const [colorIndex, setColorIndex] = useState(-1)
    const [price, setPrice] = useState(309999)
    const [freeShipping, setFreeShipping] = useState(false)

    // Store Grid
    const [sortByIndex, setSortByIndex] = useState(0)
    const [viewGrid, setViewGrid] = useState(true)

    const { response: products, error } = useFetch(`${API_BASE_URL}api/products/getAll`)

    if (error) return <Error500 />;


    const clearFilters = () => {
        setQuery('');
        setCategoryIndex(-1);
        setCompanyIndex(-1);
        setColorIndex(-1);
        setPrice(309999)
        setFreeShipping(false)
    }

    return (
        <StoreContext.Provider value={{
            cart, setCart,
            query, setQuery,
            categoryIndex, setCategoryIndex,
            freeShipping, setFreeShipping,
            price, setPrice,
            colorIndex, setColorIndex,
            companyIndex, setCompanyIndex,
            sortByIndex, setSortByIndex,
            viewGrid, setViewGrid,
            products, error,
            clearFilters
        }}>
            {products ? children : ''}
        </StoreContext.Provider>
    );
}

export { StoreProvider, StoreContext }